<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-10 pt-3 pb-3 bg-fafafa">

                <loader v-if="loaders.reading" />

                <div v-else>

                    <!-- Breadcrumb -->
                    <breadcrumb />

                    <div class="card card-body mb-3">
                        <!--@submit.prevent="updateRoom"  -->
                        <form autocomplete="off">

                            <div class="row">
                                <div class="col-lg-3">
                                    <div class="form-group">

                                        <label for="id_pathology_type">Seleziona la durata</label>

                                        <select class="form-control" id="id_duration" v-model="form.id_chair_duration">
                                            <option v-for="duration of DB.durations" :key="`durations_${duration.id}`" :value="duration.id">
                                                {{duration.title}}
                                            </option>
                                        </select>                         

                                        <small class="form-text text-muted">
                                            
                                        </small>

                                    </div>
                                </div>      
                                <!--<div class="col-lg-2">
                                    <div class="form-group">

                                        <label for="type_patient">Tipo paziente</label>

                                        <select class="form-control" id="type_patient" v-model="form.type_patient">
                                            <option :value="0">
                                                seleziona
                                            </option>                                           
                                            <option :value="1">
                                                di Roma
                                            </option>
                                            <option :value="2">
                                                fuori Roma
                                            </option>                                       
                                        </select>

                                        <small class="form-text text-muted">
                                        </small>

                                    </div>
                                </div>  -->                                                           
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <label for="title">Titolo</label>
                                        <div class="input-group">
                                            <input type="text" class="form-control" id="title" v-model.trim="$v.form.title.$model" v-bind:class="{'is-invalid': !$v.form.title.required && $v.form.title.$dirty}" required disabled>                           
                                        </div>
                                        <p v-if="!$v.form.title.required && $v.form.title.$dirty" class="m-0 text-danger">
                                            <small>
                                                Titolo richiesto
                                            </small>
                                        </p>
                                    </div>
                                </div>
                                <div class="col-lg-3">
                                    <div class="form-group">
                                        <label for="number">Numero</label>
                                        <div class="input-group">
                                            <input type="number" class="form-control" id="number" v-model.number="$v.form.number.$model" v-bind:class="{'is-invalid': !$v.form.number.required && $v.form.number.$dirty}" required disabled>                           
                                        </div>
                                        <p v-if="!$v.form.number.required && $v.form.number.$dirty" class="m-0 text-danger">
                                            <small>
                                                Numero richiesto
                                            </small>
                                        </p>
                                    </div>
                                </div>                                                     
                            </div>
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="form-group">
                                        <label for="description">Descrizione</label>
                                        <div class="input-group">
                                            <textarea class="form-control " id="description" v-model.trim="$v.form.description.$model"></textarea>                           
                                        </div>
                                    </div>
                                </div>
                            </div>       

                            <div v-show="validation.ko" class="alert alert-danger text-center">
                                {{validation.ko}}
                            </div>
                            <!--button  || !$v.$anyDirty  -->    
                            <button v-if="!functionDisabled(2, 'update')" @click="updateChair" class="btn btn-ifo" :disabled="$v.$invalid || loaders.updating || form.hour_close < form.hour_open">
                                    
                                <span v-show="!loaders.updating">
                                    Modifica
                                </span>

                                <div v-show="loaders.creating" class="spinner-border spinner-border-sm" role="status"><span class="sr-only">Loading...</span></div>

                            </button>

                        </form>

                    </div>
                    
                </div>

            </div>
            <div class="col-2 h-min-100-calc-lg_logged border-left p-0">
                <ul class="nav flex-column">
                    <li class="nav-item">
                        <a v-b-toggle.elimina v-bind:class="{'disabled': loaders.deleting || functionDisabled(14, 'delete')}" class="nav-link d-flex align-items-center justify-content-center justify-content-md-end p-3 a_bg-ifo border-bottom">
                            <span class="d-none d-md-block">Elimina</span> <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash ml-md-2 mt-md-1" viewBox="0 0 16 16">
                                <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
                                <path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>
                            </svg>
                        </a>
                        <b-collapse id="elimina">
                            <div class="alert alert-danger m-0">
                                Sicuro di voler eliminare questa poltrona?
                            </div>
                            <div class="row">
                                <div class="col-6 pr-0">
                                    <button @click="deleteChair" class="btn btn-ifo btn-block btn-sm rounded-0" :disabled="loaders.deleting">
                                    
                                        <span v-show="!loaders.deleting">
                                            Si
                                        </span>

                                        <div v-show="loaders.deleting" class="spinner-border spinner-border-sm" role="status"><span class="sr-only">Loading...</span></div>

                                    </button>
                                </div>
                                <div class="col-6 pl-0">
                                    <button v-b-toggle.elimina class="btn btn-ifo btn-block btn-sm rounded-0">No</button>
                                </div>
                            </div>
                        </b-collapse>
                    </li>
                    <li class="nav-item">
                        <a @click="suspendChair" v-bind:class="{'disabled': loaders.suspending || functionDisabled(14, 'update')}" class="nav-link d-flex align-items-center justify-content-center justify-content-md-end p-3 a_bg-ifo border-bottom">
                            
                            <span class="d-none d-md-block" v-if="!loaders.suspending && form.state">Rendi non visibile</span> <svg v-show="!loaders.suspending && form.state" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pause-circle ml-md-2" viewBox="0 0 16 16">
                                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                <path d="M5 6.25a1.25 1.25 0 1 1 2.5 0v3.5a1.25 1.25 0 1 1-2.5 0v-3.5zm3.5 0a1.25 1.25 0 1 1 2.5 0v3.5a1.25 1.25 0 1 1-2.5 0v-3.5z"/>
                            </svg>
                        
                            <span class="d-none d-md-block" v-if="!loaders.suspending && !form.state">Rendi visibile</span> <svg v-show="!loaders.suspending && !form.state" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-play-circle ml-md-2" viewBox="0 0 16 16">
                                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                <path d="M6.271 5.055a.5.5 0 0 1 .52.038l3.5 2.5a.5.5 0 0 1 0 .814l-3.5 2.5A.5.5 0 0 1 6 10.5v-5a.5.5 0 0 1 .271-.445z"/>
                            </svg>

                            <div v-show="loaders.suspending" class="spinner-border spinner-border-sm" role="status"><span class="sr-only">Loading...</span></div>

                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>

    import { 
        required
    } from "vuelidate/lib/validators"

    import moment from "moment"
    import store  from "@/store"

    export default {
        data() {
            return {
                DB: {
                    durations: []
                },                   
                form: {
                    title:       null,
                    number:      null,
                    description: null, 
                    id_chair_duration: 0,
                    type_patient: 0                                
                },
                validation: {
                    ko: false,
                    conflict:  false
                },
                loaders: {
                    reading:    true,
                    updating:   false,
                    deleting:   false,
                    suspending: false
                },
                utility: {
                    today: moment().format("YYYY-MM-DD")
                },
                calendar: {
                    config: {
                        minDate:      moment().format("YYYY-MM-DD"),
                        maxDate:      null,
                        timeFrom:     8*60,
                        timeTo:       20*60,
                        timeStep:     30,
                        roomSelected: {},
                        events:       [],
                        hideWeekDays: [],
                        selectedDate: null,
                        specialHours: null
                    }
                },                             
            }
        },
        validations() {
            return {
                form: {
                    title: {
                        required
                    },                 
                    number: {
                        required
                    },               
                    id_chair_duration: {
                        required
                    },
                    description: {

                    }                                                    
                }
            }
        },
        methods: {   
            async read_durations() {
                try {

                    this.DB.durations = (
                        await this.axios.get(`user/chairs_duration/read/all`, {
                            headers:{
                                Authorization: `bearer ${this.$store.state.auth.token}`
                            }
                        })
                    ).data

                }
                catch(e) {

                    this.$toast.open({
                        message: e.response.data.msg,
                        type:   `error`
                    })

                }

            },                                                                                                                         
            async updateChair() {

                this.loaders.updating = true

                try {

                    const chair = await this.axios.post(`user/chairs/update`, this.form,
                    {
                        headers:{
                            Authorization: `bearer ${this.$store.state.auth.token}`
                        }
                    })

                    this.$toast.open({
                        message: chair.data.msg,
                        type:   `success`
                    })
                    
                }
                catch(e) {

                    this.$toast.open({
                        message: e.response.data.msg,
                        type:   `error`
                    })

                }
                finally {
                    this.loaders.updating = false
                }
                
                
            },
            async readChair() {

                try {

                    const chair = await this.axios.get(`user/chairs/read/detail/${this.$route.params.title}/${this.$route.params.number}`, {
                        headers:{
                            Authorization: `bearer ${this.$store.state.auth.token}`
                        }
                    })

                    this.form = chair.data
                    
                }
                catch(e) {

                    this.$toast.open({
                        message: e.response.data.msg,
                        type:   `error`
                    })

                    this.$router.go(-1)

                }
                finally {
                    this.loaders.reading = false
                }

            },
            async deleteChair() {

                this.loaders.deleting = true

                try {

                    const res = await this.axios.delete(`user/chairs/${this.$route.params.title}/${this.$route.params.number}`, {
                        headers:{
                            Authorization: `bearer ${this.$store.state.auth.token}`
                        }
                    })

                    this.$toast.open({
                        message: res.data.msg,
                        type:   `success`
                    })

                    this.$router.push(`/user/poltrone`)
                    
                }
                catch(e) {

                    this.$toast.open({
                        message: e.response.data.msg,
                        type:   'error'
                    })

                    this.loaders.deleting = false

                }

            },
            async suspendChair() {

                this.loaders.suspending = true

                try {

                    const res = await this.axios.get(`user/chairs/suspend/${this.$route.params.title}/${this.$route.params.number}`, {
                        headers:{
                            Authorization: `bearer ${this.$store.state.auth.token}`
                        }
                    })

                    this.$toast.open({
                        message: res.data.msg,
                        type:   'success'
                    })

                    this.form.state = !this.form.state
                    
                }
                catch(e) {

                    this.$toast.open({
                        message: e.response.data.msg,
                        type:   'error'
                    })

                }
                finally {
                    this.loaders.suspending = false
                }

            },
            functionDisabled(id_function, action) {
                for(let sFunction of store.getters.softwareFunctions) {
                    if(sFunction.id_software_functions == id_function && !sFunction[action]) {
                        return true
                    }
                }
            }
        },
        mounted() {
            this.read_durations()
            this.readChair()
        }
    }

</script>